import { APP } from 'libs/constants';
import _ from 'lodash';

export function getPlanOffer(products, type) {
  let offer = null;
  for (let index = 0; index < products.length; index += 1) {
    const product = products[index];
    if (product.billingPeriod === type) {
      const { discount } = product;
      offer = discount.percentage;
    }
  }
  return offer;
}

export function hasSubscriptions(userSubscriptions = []) {
  return !!userSubscriptions.length;
}

export function checkNonTrialActiveSubscription(userSubscriptions = []) {
  if (hasSubscriptions(userSubscriptions)) {
    const museSubscribedPlan = userSubscriptions[0];
    const { isTrial } = museSubscribedPlan;
    return !isTrial;
  }
  return false;
}

export function checkTrialSubscriptionWithPlan(userSubscriptions = []) {
  if (hasSubscriptions(userSubscriptions)) {
    const museSubscribedPlan = userSubscriptions[0];
    const { isTrial, isRenewing } = museSubscribedPlan;
    return isTrial && isRenewing;
  }
  return false;
}

export function checkTrialSubscriptionWithoutPlan(userSubscriptions = [], appName = APP.muse) {
  if (hasSubscriptions(userSubscriptions)) {
    for (let index = 0; index < userSubscriptions.length; index += 1) {
      const { isTrial, isRenewing, app } = userSubscriptions[index];
      if (app === appName) {
        return isTrial && !isRenewing;
      }
    }
  }
  return false;
}

export function hadNoTrialOrPromoSubs(user = {}, app = APP.muse) {
  const { introOfferEligible = [] } = user;
  return introOfferEligible.includes(app);
}

export function getCheckoutPayload(details = {}) {
  const { plan, nonTrial, coupon } = details;
  const payload = {
    app: APP.muse,
    plan: plan.planID,
    non_trial: nonTrial
  };
  const isCouponApply = _.includes(plan.billingPeriod, 'annual');
  if (coupon && isCouponApply) {
    payload.coupon = coupon;
  }
  return payload;
}



// WEBPACK FOOTER //
// ./src/libs/musePromoPlans.js